import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  environment,
  HttpBaseUrlAppenderInterceptor,
  HttpForceCamelCaseInterceptor,
  MyHttpHandler,
} from '@ups/xplat/core';
import {
  ChangePasswordDto,
  LoginDto,
  LoginResultDto,
  PasswordChangeResultDto,
  PasswordResetDto,
  PasswordResetInfoDto,
  PasswordResetInfoRequestDto,
  PasswordResetRequestDto,
  PasswordResetRequestResponseDto,
  RefreshDto,
  TokenPairDto,
} from './model';

@Injectable({ providedIn: 'root' })
export class InternalAuthApiService {
  http: HttpClient;

  constructor(
    backend: HttpBackend,
    forceCamelCaseInterceptor: HttpForceCamelCaseInterceptor
  ) {
    const handler = new MyHttpHandler(backend, [
      new HttpBaseUrlAppenderInterceptor(
        `${environment.security?.apiUrl}/api/InternalAuth/`
      ),
      forceCamelCaseInterceptor,
    ]);
    this.http = new HttpClient(handler);
  }

  login(data: LoginDto) {
    return this.http.post<LoginResultDto>('login', data);
  }

  logout(accessToken: string) {
    return this.http.post('logout', null, {
      headers: { authorization: `Bearer ${accessToken}` },
    });
  }

  refresh(data: RefreshDto) {
    return this.http.post<TokenPairDto>('refresh', data);
  }

  requestPasswordReset(data: PasswordResetRequestDto) {
    return this.http.post<PasswordResetRequestResponseDto>(
      'requestPasswordReset',
      data
    );
  }

  passwordResetInfo(data: PasswordResetInfoRequestDto) {
    return this.http.post<PasswordResetInfoDto>('passwordResetInfo', data);
  }

  resetPassword(data: PasswordResetDto) {
    return this.http.post<PasswordChangeResultDto>('resetPassword', data);
  }

  changePassword(data: ChangePasswordDto, accessToken: string) {
    return this.http.post<PasswordChangeResultDto>('changePassword', data, {
      headers: { authorization: `Bearer ${accessToken}` },
    });
  }
}
